import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { ClientRender } from '@change-corgi/core/react/ssr/render';

import {
	StarterDashboardV2BreakpointStateProvider,
	useStarterDashboardV2PageNotificationManagerContext,
} from 'src/app/pages/starterDashboardV2/pageContext';

import { PageBody } from '../components/PageBody';
import { PageHeader } from '../components/PageHeader';
import { useDashboardReskinExperiment } from '../hooks/useDashboardReskinExperiment';

import { useTrackPageView } from './hooks/useTrackPageView';
import { LayoutReskin } from './index_new';

export function Layout(): JSX.Element {
	const { section } = useKnownAvailableParams();

	useTrackPageView(section);

	const {
		data: { isEnabled: isReskinEnabled },
	} = useDashboardReskinExperiment();
	const {
		data: { notification },
	} = useStarterDashboardV2PageNotificationManagerContext();

	if (isReskinEnabled) {
		return <LayoutReskin />;
	}

	// We depend on client breakpoints
	return (
		<ClientRender placeholder={<div className="h-16" />}>
			<StarterDashboardV2BreakpointStateProvider>
				<PageHeader />
				<div className="bg-fill-weaker h-full w-full">
					{notification?.content}
					<PageBody />
				</div>
			</StarterDashboardV2BreakpointStateProvider>
		</ClientRender>
	);
}
